import PublicLayout from './PublicLayout';
import useFetch from './useFetch';
import { getPublic } from './api';

const STEPS = [
  ['Create an account', 'Register in the app with your mobile number and a password. It takes under a minute.'],
  ['Add points', 'Top up your wallet from the app. Your balance updates once the payment is confirmed.'],
  ['Pick a market', 'Choose a market that is still open, pick a game type, and enter your numbers.'],
  ['Place your bid', 'Enter how many points you want to stake. The amount is taken from your wallet straight away.'],
  ['Wait for the result', 'Open and close numbers are declared at the market’s timings and shown on the Results page.'],
  ['Winnings are automatic', 'If your bid wins, the points are credited to your wallet as soon as the result is declared.'],
];

const WITHDRAW = [
  ['Add a payment method', 'In the app, save the UPI ID or bank account you want to be paid to.'],
  ['Request a withdrawal', 'Enter the number of points to withdraw. The points leave your wallet immediately and the request goes to the admin.'],
  ['Admin review', 'The request is checked and either approved or rejected.'],
  ['Money or refund', 'Approved requests are paid to your saved method. If a request is rejected, the points are returned to your wallet in full.'],
];

export default function HowToPlayPage() {
  const { data: types } = useFetch(() => getPublic('/game-types'), []);

  return (
    <PublicLayout
      title="How to Play"
      description="How to play, what each game type means, and how withdrawals work."
    >
      <div className="wrap page">
        <span className="eyebrow">Guide</span>
        <h1>How to play</h1>
        <p className="lede">Everything from creating an account to getting your winnings out.</p>

        <div className="grid g3" style={{ marginBottom: 40 }}>
          {STEPS.map(([t, b], i) => (
            <div key={t} className="card mkt">
              <div className="top">
                <span className="logo" style={{ width: 28, height: 28, fontSize: 12 }}>{i + 1}</span>
                <span className="nm" style={{ flex: 1 }}>{t}</span>
              </div>
              <p style={{ margin: 0, color: 'var(--muted)', fontSize: 14 }}>{b}</p>
            </div>
          ))}
        </div>

        <h2>Game types</h2>
        <p className="lede">Each market supports all of these. See the Game Rates page for what they pay.</p>
        <div className="grid g4" style={{ marginBottom: 40 }}>
          {(types.length ? types : []).map((t) => (
            <div key={t.id} className="card mkt">
              <span className="nm">{t.name}</span>
            </div>
          ))}
        </div>

        <h2>How withdrawals work</h2>
        <p className="lede">Payouts are reviewed by an admin before the money is sent.</p>
        <div className="grid g4" style={{ marginBottom: 34 }}>
          {WITHDRAW.map(([t, b], i) => (
            <div key={t} className="card mkt">
              <div className="top">
                <span className="logo" style={{ width: 28, height: 28, fontSize: 12 }}>{i + 1}</span>
                <span className="nm" style={{ flex: 1 }}>{t}</span>
              </div>
              <p style={{ margin: 0, color: 'var(--muted)', fontSize: 14 }}>{b}</p>
            </div>
          ))}
        </div>

        <div className="note">
          <p><b style={{ color: 'var(--gold)' }}>Before you play.</b> Every bid is a real-money stake and most bids lose. Decide what you can afford to lose before you start, and stop when you reach it.</p>
          <p>Never play to win back money you have already lost, and never borrow money to play. If it stops feeling like a choice, stop and talk to someone you trust.</p>
        </div>
      </div>
    </PublicLayout>
  );
}
